import React from 'react'
import "./header.css"

const CTA = () => {
  return (
    <div className="cta">
      <a href="https://drive.google.com/file/d/1jhAI2P-rOkqiBffWGxiTc5mUAJ6yBG2g/view?usp=sharing" target='_blank' className='btn '>Download CV</a>
      <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default CTA